module.exports = __webpack_public_path__ + "img/arweave_org.25831591.png";